<template>
    <password-reset-component @submitNewPassword="handleSubmitNewPassword"></password-reset-component>
</template>

<script>
import PasswordResetComponent from '@/components/user/PasswordResetComponent'
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
export default {
  name: 'PasswordReset',
  components: {PasswordResetComponent},
  props: ["uid", "token"],
  computed: {
    ...mapGetters([
      'base_url'
    ]),
  },
  methods: {        
    ...mapMutations([
      'SET_BREADCRUMB'
    ]),
    setBreadcrumb: function(){
      this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
    },
    handleSubmitNewPassword: function(user) {
      user["uid"] = this.uid
      user["token"] = this.token
      // {uid: this.uid, token: this.token, password1: user.password1, password2: user.password2}
      axios.post(`${this.base_url}accounts/password/reset/confirm/`, user)
        .then(response => {
          console.log('response: ', response)
          this.$toast.open({
              duration: 5000,
              type: 'is-success',
              message: `New password set successfully`,
              icon: 'info_outline',
              position: "is-top",
          });
          this.$router.push({ name: "Login" });
        })
        .catch(error => {
          console.log("Validation error:", error.response.data)
          this.$toast.open({
            type: 'is-danger',
            icon: 'error_outline',
            duration: 5000,
            position: "is-top",
            message: "Something went wrong"
          });
          
        })
    }
  },
  mounted(){
    this.setBreadcrumb(),
    console.log(this.uid)
    console.log(this.token)
  }
}
</script>

<style>

</style>
